import { MultiLocationStrategy } from './multilocationstrategy';
import { NgModule, Compiler, Injector, Optional, ModuleWithProviders } from '@angular/core';
import {
  RouterModule, Router, UrlSerializer, ChildrenOutletContexts, ROUTES, ROUTER_CONFIGURATION,
  UrlHandlingStrategy, PreloadingStrategy, NoPreloading, provideRoutes, Routes, ExtraOptions, Route
} from '@angular/router';
import { ɵROUTER_PROVIDERS as ROUTER_PROVIDERS } from '@angular/router';
import { LocationStrategy, Location } from '@angular/common';
import { environment } from '../../environments/environment';
import { ES5ZoneAwareRouter } from './es5ZoneAwareRouter';

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function setupElementsRouter(_urlSerializer: UrlSerializer, _contexts: ChildrenOutletContexts, _location: Location,
                                    _compiler: Compiler, _injector: Injector,
                                    _routes: Route[][], _opts?: ExtraOptions,
                                    _urlHandlingStrategy?: UrlHandlingStrategy): Router {
  const r = new Router();
  r.config.concat(([] as Route[]).concat(..._routes));
  if (environment.enableRouterTracing) {
    // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
    r.events.subscribe(function(e) {
      const msg = 'CUI Router Event: ' + e.constructor.name
        + '\n' + e.toString()
        + '\n' + e;
      /* eslint-disable-next-line */
      console.log(msg);
    });
  }
  return r;
}

/***
 * From https://medium.com/@timon.grassl/how-to-use-routing-in-angular-web-components-c6a76449cdb
 */
@NgModule({
            exports: [ RouterModule ],
            providers: [
              ROUTER_PROVIDERS, { provide: Location, useClass: Location },
              { provide: LocationStrategy, useClass: MultiLocationStrategy },
              {provide: Router,
                useFactory: setupElementsRouter,
                deps: [
                  UrlSerializer, ChildrenOutletContexts, Location, Compiler, Injector,
                  ROUTES, ROUTER_CONFIGURATION, [ UrlHandlingStrategy, new Optional() ]
                ]
              },
              { provide: PreloadingStrategy, useExisting: NoPreloading },
              { provide: ES5ZoneAwareRouter, useClass: ES5ZoneAwareRouter },
              provideRoutes([])
            ]
          })
export class ElementRoutingModule {
  static withRoutes(routes: Routes, config?: ExtraOptions):
    ModuleWithProviders<ElementRoutingModule> {
    return {
      ngModule: ElementRoutingModule,
      providers: [
        provideRoutes(routes),
        { provide: ROUTER_CONFIGURATION, useValue: config ? config : {} },
      ]
    };
  }
}
